const $ = jQuery.noConflict();

const ProgramsContent = {
    triggerContent: $('.block-programs__more'),
    triggerMore: $('.block-programs__load-more'),
    contentSelector: '.block-programs__item-content',
    endMessage: $('.block-programs__no-found'),

    loadMore() {
        const blocksHidden = $('.block-programs__item.hide:lt(4)');
        const timer = 80;
        const endAnimation = timer * 4;

        const currentTop = $(window).scrollTop();

        blocksHidden.each( (i, e) => {
            setTimeout( () => {
                e.classList.remove('hide');
                $(window).scrollTop( currentTop );
            }, timer * i );
        } );

        setTimeout( () => {
            if ( $('.block-programs__item.hide:lt(4)').length === 0 ) {
                this.endMessage.removeClass('d-none');
                this.triggerMore.hide();
            }
        }, endAnimation);
    },

    toggleContent() {
        const target = $( event.target );

        const parentWrapper = target.closest( '.block-programs__item-wrapper' );
        const content = parentWrapper.find( '.block-programs__item-content' );

        if ( !content.hasClass('extend') ) {
            target.parent().addClass('active');
            content.addClass('extend');
        } else {
            target.parent().removeClass('active');
            content.removeClass('extend');
        }
    },

    bindEvents() {
        this.triggerContent.on('click', () => {
            this.toggleContent();
        });
        this.triggerMore.on('click', () => {
            this.loadMore();
        });
    },

    init() {
        this.bindEvents();
    }
}

export default ProgramsContent;